import React, { useEffect, useRef, useState } from 'react'
import '../styles/MyBusiness.scss'
import { Button, ButtonGroup, Container, Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import PermanceImage from '../assets/imgs/stylers-images/performance-image.png'
import '../styles/Services.scss'
import ReviewerImage from '../assets/imgs/stylers-images/reviwer-image.png'
import CustomDropdown from './styled/CustomDropdown'
import StarIcon from '@mui/icons-material/Star'
import CheckCircleIcon from '../assets/imgs/stylers-images/check-circle.svg'
import { Bar } from 'react-chartjs-2'
import { Line, Chart } from 'react-chartjs-2'
import ChevronRightIcon from '../assets/imgs/profile-screen-images/chevron.png'
import ChevronLeftIcon from '../assets/imgs/profile-screen-images/chevron-right-profile.png'
import GoldStylistCard from '../assets/imgs/gold-stylist-card.svg'
import SilverStylistCard from '../assets/imgs/silver-stylist-card.svg'
import { ScaleLoader } from 'react-spinners'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  GridLineOptions as GridOptions,
} from 'chart.js'
import ReviewCard from './Cards/ReviewCard'
import { getDataById } from '../apis/generalApis'

function TabPanel(props) {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

let oneStarRatingPercentage = 0,
  twoStarRatingPercentage = 0,
  threeStarRatingPercentage = 0,
  fourStarRatingPercentage = 0,
  fiveStarRatingPercentage = 0

const MyBusiness = (props) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [stylistPerformance, setStylistPerformance] = useState(null)
  const [earningsFilterOption, setEarningsFilterOption] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [reviewsFilterOption, setReviewsFilterOption] = useState(null)
  const [dailyChart, setDailyChart] = useState(true)

  useEffect(() => {
    getWeeklyReports({ stylist_id: user?.id })
  }, [])

  useEffect(() => {
    getStylistPerformance({
      stylist_id: user?.id,
      months: reviewsFilterOption?.value,
    })
  }, [reviewsFilterOption])

  useEffect(() => {
    let body
    if (earningsFilterOption?.value) {
      body = {
        stylist_id: user?.id,
        year: earningsFilterOption?.value,
      }
    } else {
      body = {
        stylist_id: user?.id,
      }
    }
    getMonthlyReports(body)
  }, [earningsFilterOption])

  const getStylistPerformance = async (body) => {
    setIsLoading(true)
    let result = await getDataById('show-performance', body)
    setIsLoading(false)
    if (result?.success === true) {
      setStylistPerformance(result?.data)
      setReviews(result?.reviews)
      let oneStarRatingReviews,
        twoStarRatingReviews,
        threeStarRatingReviews,
        fourStarRatingReviews,
        fiveStarRatingReviews
      oneStarRatingReviews = result?.reviews?.filter(
        (item) => item?.rating === 1,
      )
      twoStarRatingReviews = result?.reviews?.filter(
        (item) => item?.rating === 2,
      )
      threeStarRatingReviews = result?.reviews?.filter(
        (item) => item?.rating === 3,
      )
      fourStarRatingReviews = result?.reviews?.filter(
        (item) => item?.rating === 4,
      )
      fiveStarRatingReviews = result?.reviews?.filter(
        (item) => item?.rating === 5,
      )
      oneStarRatingPercentage =
        (oneStarRatingReviews?.length * 100) / result?.reviews?.length
      twoStarRatingPercentage =
        (twoStarRatingReviews?.length * 100) / result?.reviews?.length
      threeStarRatingPercentage =
        (threeStarRatingReviews?.length * 100) / result?.reviews?.length
      fourStarRatingPercentage =
        (fourStarRatingReviews?.length * 100) / result?.reviews?.length
      fiveStarRatingPercentage =
        (fiveStarRatingReviews?.length * 100) / result?.reviews?.length
    }
  }
  const performanceDropdownOptions = [
    { label: 'For How Long?', value: null },
    { label: `${new Date().getFullYear()}`, value: new Date().getFullYear() },
    {
      label: `${new Date().getFullYear() - 1}`,
      value: new Date().getFullYear() - 1,
    },
    {
      label: `${new Date().getFullYear() - 2}`,
      value: new Date().getFullYear() - 2,
    },
    {
      label: `${new Date().getFullYear() - 3}`,
      value: new Date().getFullYear() - 3,
    },
    {
      label: `${new Date().getFullYear() - 4}`,
      value: new Date().getFullYear() - 4,
    },
    { label: 'All Time', value: null },
  ]

  const [reviews, setReviews] = useState([])
  const [monthlyReports, setMonthlyReports] = useState({
    orders: {},
    sales: {},
    performance: {},
    currentMonthOrder: 0,
    currentMonthSale: 0,
    currentMonthHours: 0,
  })
  const [weeklyReports, setWeeklyReports] = useState({
    orders: [],
    sales: [],
    todayOrder: 0,
    todaySale: 0,
    todayHours: 0,
  })
  const reviewsSection = useRef()

  const scrollReviews = (scrollValue) => {
    reviewsSection.current.scrollLeft += scrollValue
  }

  // const getStylistReviews = async () => {
  //   let body = {
  //     stylist_id: user?.id,
  //   }
  //   let result = await getDataById('show-stylist-reviews', body)
  //   if (result?.data != null) {
  //     if (result?.success === true) {
  //       setReviews(result?.data)
  //     }
  //   }
  // }

  const getMonthlyReports = async (body) => {
    setIsLoading(true)
    let result = await getDataById('monthly-reports', body)
    setIsLoading(false)
    let sales = Object.values(monthlyReports.sales)
    // console.log({ sales })
    setMonthlyReports((prev) => ({
      ...prev,
      orders: result?.orders,
      sales: result?.sales,
      performance: result?.performance,
      currentMonthHours: result?.currentMonthHours,
      currentMonthOrder: result?.currentMonthOrder,
      currentMonthSale: result?.currentMonthSale,
    }))
  }

  const getWeeklyReports = async (body) => {
    setIsLoading(true)
    let result = await getDataById('weekly-reports', body)
    setIsLoading(false)
    let sales = Object.values(monthlyReports.sales)
    // console.log({ sales })
    setWeeklyReports((prev) => ({
      ...prev,
      orders: result?.orders,
      sales: result?.sales,
      todayOrder: result?.todayOrder,
      todaySale: result?.todaySale,
      todayHours: result?.todayHours,
    }))
  }

  let canvas = window.document.getElementsByTagName('canvas')[0]

  const reviewsTab = React.useRef(null)
  const [activeTab, setActiveTab] = React.useState(0)
  const [canvasTag, setCanvasTag] = React.useState({ count: 0, canvas: null })

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
  )

  const lineChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        grid: {
          drawBorder: false,
        },
        ticks: {
          color: '#08c4bb',
          fontSize: 24,
          beginAtZero: true,
          callback: function (tickValue) {
            return '$' + tickValue
          },
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
      },
    },
  }

  const lineChartLabels = ['M', 'T', 'W', 'T', 'F', 'S', 'S']

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    datasets: {
      label: {
        display: false,
      },
    },
    scales: {
      y: {
        ticks: {
          color: '#08c4bb',
          fontSize: 24,
          beginAtZero: true,
          callback: function (tickValue) {
            return '$' + tickValue
          },
        },
        grid: {
          drawBorder: false,
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
      },
    },
  }
  const labels = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  if (canvasTag.count < 1 && canvas) {
    setCanvasTag({ ...canvasTag, canvas: canvas, count: canvasTag.count + 1 })
  }
  let ctx, gradient
  if (canvasTag.canvas) {
    ctx = canvasTag.canvas.getContext('2d')
    gradient = ctx.createLinearGradient(0, 0, 0, 400)
    gradient.addColorStop(0, '#01CED1')
    gradient.addColorStop(0.4, '#14B1E4')
    gradient.addColorStop(1, '#2992FB')
  }
  const data = {
    labels: labels,
    datasets: [
      {
        label: '',
        // data: [75, 225, 190, 75, 175, 300, 160, 250, 350, 300, 250, 400],
        data: Object.values(monthlyReports?.sales),
        backgroundColor: gradient ? gradient : '#18AEE6',
        borderColor: function (context) {
          const chart = context.chart
          const { ctx, chartArea } = chart

          if (!chartArea) {
            // This case happens on initial chart load
            return
          }
          return getGradient(ctx, chartArea)
        },
        // borderWidth: 1,
        barThickness: 10,
      },
    ],
  }

  // const lineChartData = {
  //   labels: lineChartLabels,
  //   datasets: [
  //     {
  //       data: [200, 250, 150, 125, 150, 350, 400],
  //       fill: false,
  //       borderColor: '#08c4bb',
  //       tension: 0.1,
  //     },
  //   ],
  // }

  const lineChartData = {
    labels: lineChartLabels,
    datasets: [
      {
        data: Object.values(weeklyReports?.sales),
        data: [],
        fill: false,
        borderColor: '#08c4bb',
        tension: 0.1,
      },
    ],
  }

  let width, height, gradient1
  function getGradient(ctx, chartArea) {
    const chartWidth = chartArea.right - chartArea.left
    const chartHeight = chartArea.bottom - chartArea.top
    if (!gradient1 || width !== chartWidth || height !== chartHeight) {
      // Create the gradient because this is either the first render
      // or the size of the chart has changed
      width = chartWidth
      height = chartHeight
      gradient1 = ctx.createLinearGradient(
        0,
        chartArea.bottom,
        0,
        chartArea.top,
      )
      gradient1.addColorStop(0, '#01CED1')
      gradient1.addColorStop(0.5, '#14B1E4')
      gradient1.addColorStop(1, '#2992FB')
    }

    return gradient1
  }

  return (
    // <ThemeProvider theme={theme}>
    <div className="my-business">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="row h-100 m-0">
        <div
          className="col-md-7 col-xs-12 col-sm-12 tab-wrapper"
          style={{ backgroundColor: '#F5F5F5' }}
        >
          <Container className="my-business-left-panel">
            <div className="container">
              <div className="custom-tabs d-flex mt-3">
                <div
                  className={`tab ${activeTab === 0 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(0)}
                >
                  <p className="fs-24 color-primary">Performance</p>
                </div>
                <div
                  className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(1)}
                >
                  <p className="fs-24 color-primary">Reviews</p>
                </div>
                <div
                  className={`tab ${activeTab === 2 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(2)}
                >
                  <p className="fs-24 color-primary">Earnings</p>
                </div>
              </div>
              <div className="tabs-content my-4">
                {activeTab === 0 && (
                  <div className="performance-tab px-3">
                    <div className="completed-jobs performance-card px-3 py-4 row">
                      <div className="percentage-wraper col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 d-flex justify-content-center align-items-center">
                        {/* <div> */}
                        <h1
                          className="fs-46 text-black"
                          style={{ fontWeight: '400' }}
                        >
                          {monthlyReports?.performance?.complete_jobs}%
                        </h1>
                        {/* </div> */}
                      </div>
                      <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                        <h1 className="fs-4 text-black font-weight-bold">
                          Completed Jobs
                        </h1>
                        <p className="fs-5">
                          You honored{' '}
                          {user?.complete_jobs > 3 ? 3 : user?.response_rate}{' '}
                          out of 3 requests.
                        </p>
                        <p className="fs-24 m-0">
                          High five! You continually go the extra mile and give
                          your guests the 5 star treatment.
                        </p>
                      </div>
                    </div>
                    <div className="response-rate performance-card px-3 py-4 mt-3 row">
                      <div className="percentage-wraper col-md-3 col-xs-12 col-sm-12 d-flex justify-content-center align-items-center">
                        {/* <div> */}
                        <h1
                          className="fs-46 text-black"
                          style={{ fontWeight: '400' }}
                        >
                          {monthlyReports?.performance?.response_rate}%
                        </h1>
                        {/* </div> */}
                      </div>
                      <div className="col-md-9 col-sm-12 col-xs-12">
                        <h1 className="fs-4 text-black font-weight-bold">
                          Response Rate
                        </h1>
                        <p className="fs-5">
                          Your honored{' '}
                          {user?.response_rate > 3 ? 3 : user?.response_rate}{' '}
                          out of 3 requests.
                        </p>
                        <p className="fs-24 m-0">
                          High five! You continually go the extra mile and give
                          your guests the 5 star treatment.
                        </p>
                      </div>
                    </div>
                    <div className="acceptance-rate performance-card px-3 py-4 mt-3 row">
                      <div className="percentage-wraper col-md-3 col-xs-12 col-sm-12 d-flex justify-content-center align-items-center">
                        {/* <div> */}
                        <h1
                          className="fs-46 text-black"
                          style={{ fontWeight: '400' }}
                        >
                          {monthlyReports?.performance?.acceptance_rate}%
                        </h1>
                        {/* </div> */}
                      </div>
                      <div className="col-md-9 col-sm-12 col-xs-12">
                        <h1 className="fs-4 text-black font-weight-bold">
                          Acceptance Rate
                        </h1>
                        <p className="fs-5">
                          Your honored{' '}
                          {user?.acceptance_rate > 3
                            ? 3
                            : user?.acceptance_rate}{' '}
                          out of 3 requests.
                        </p>
                        <p className="fs-24 m-0">
                          High five! You continually go the extra mile and give
                          your guests the 5 star treatment.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 1 && (
                  <div
                    className="reviews-tab px-3"
                    style={{ height: '70vh', overflow: 'auto' }}
                  >
                    <div
                      className={`position-relative col-12 col-sm-12 col-md-8 w-100 ${
                        reviews?.length === 0 ? 'd-none' : ''
                      }`}
                    >
                      <img
                        src={ChevronRightIcon}
                        onClick={() => scrollReviews(500)}
                        className="service-slider-icon pointer"
                      />
                      <img
                        src={ChevronLeftIcon}
                        onClick={() => scrollReviews(-500)}
                        className="service-slider-icon pointer left"
                      />
                      <div
                        className="row gy-2 pb-2 flex-nowrap overflow-auto"
                        ref={reviewsSection}
                        style={{ scrollBehavior: 'smooth' }}
                      >
                        {reviews?.map((review, index) => (
                          <div
                            className="col-10 col-sm-9 col-lg-9 col-xl-6 col-xxl-5"
                            key={review.id}
                          >
                            <ReviewCard review={review} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 2 && (
                  <div
                    className="reviews-tab px-3"
                    id="reviews-tab"
                    ref={reviewsTab}
                  >
                    <button className="daily-earning-btn py-3">
                      {dailyChart ? 'Daily Earning' : 'Monthly Earning'}
                    </button>
                    <div>
                      <div className="d-flex justify-content-between align-items-center px-5 mt-4 color-primary">
                        <p className="fs-18 m-0">
                          $
                          {dailyChart
                            ? weeklyReports?.todaySale
                            : monthlyReports?.currentMonthSale}
                        </p>
                        <p className="fs-18 m-0">
                          {dailyChart
                            ? weeklyReports?.todayHours
                            : monthlyReports?.currentMonthHours}
                        </p>
                        <p className="fs-18 m-0">
                          {dailyChart
                            ? weeklyReports?.todayOrder
                            : monthlyReports?.currentMonthOrder}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center px-5 my-3">
                        <p className="fs-18 m-0">
                          {dailyChart ? 'Today' : 'July 2020'}
                        </p>
                        <p className="fs-18 m-0">Hours</p>
                        <p className="fs-18 m-0">Clients</p>
                      </div>
                    </div>

                    {!dailyChart && <Bar options={options} data={data} />}
                    {dailyChart && (
                      <Line data={lineChartData} options={lineChartOptions} />
                    )}
                    <div className="text-center mt-4">
                      <ButtonGroup
                        className="button-group"
                        disableElevation
                        variant="contained"
                      >
                        <Button
                          onClick={() => setDailyChart(true)}
                          className={`${dailyChart === true ? 'active' : ''}`}
                        >
                          Daily
                        </Button>
                        <Button
                          onClick={() => setDailyChart(false)}
                          className={`${!dailyChart === true ? 'active' : ''}`}
                        >
                          Monthly
                        </Button>
                      </ButtonGroup>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
        <div
          className="col-md-5 col-sm-12 col-xs-12"
          style={{ backgroundColor: '#fff' }}
        >
          <div className="text-center container">
            {activeTab === 0 && (
              <div>
                <img
                  src={PermanceImage}
                  alt="Performance Tips"
                  height={58}
                  width={58}
                  className="mt-3"
                />
                <p
                  className="font-weight-bold my-2"
                  style={{ fontSize: '18px' }}
                >
                  Performance Tips
                </p>
                <p className="fs-18 mb-3">
                  Great hosts are prepared, responsive, and always follow
                  through on accepted bookings. Follow these simple tips to
                  improve your performance:
                </p>
                <ul className="text-left">
                  <li className="fs-16">
                    Keep your calendar up-to-date and set pickup & return hours
                    so you only get trips that work for you.
                  </li>
                  <li className="fs-16">
                    Adjust preferences for your listings, including advance
                    notice and style duration settings.
                  </li>
                  <li className="fs-16">
                    Download the app and turn on notifications to keep up with
                    your trip requests and schedule.
                  </li>
                  <li className="fs-16">
                    Learn more about how BodeWrk evaluates Provider performance.
                  </li>
                </ul>
                <div className="text-center mt-5">
                  <p className="fs-24 font-weight-bod mb-1">
                    Silver Stylist and Gold Stylist Qualifier
                  </p>
                  <p className="fs-14">
                    Make more from every job. Get a Silver or <br /> Gold Badge
                    on your profile
                  </p>
                  <img
                    src={SilverStylistCard}
                    alt=""
                    className="mt-3 d-block m-auto"
                  />
                  <img
                    src={GoldStylistCard}
                    alt=""
                    className="mt-2 d-block m-auto"
                  />
                </div>
              </div>
            )}
            {activeTab === 1 && (
              <div>
                <div className="my-4">
                  <CustomDropdown
                    title={'Show Performance'}
                    setFilterOption={setReviewsFilterOption}
                    filterOption={reviewsFilterOption}
                    isYearlyDropdown={false}
                  />
                </div>
                {/* <div>
                  <h3 className="text-black font-weight-bold">
                    Show Performance
                  </h3>
                  <p className="fs-18 mt-3">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    Eligendi quasi natus quos? Maiores asperiores.
                  </p>
                </div> */}
                <div className="d-flex justify-content-between align-items-center my-5">
                  <div className="d-flex align-items-center">
                    <p className="fs-32 m-0">
                      {stylistPerformance?.avg_rating ?? 'Not Rated'}
                    </p>
                    <StarIcon
                      style={{
                        fontSize: '30px',
                        color: '#C9A858',
                      }}
                    />
                  </div>
                  <p className="fs-24 font-weight-bold m-0">
                    Overall Performance
                  </p>
                </div>
                <div className="rating">
                  <p className="fs-24 font-weight-bold text-left mb-3">
                    Ratings ({stylistPerformance?.total_reviews ?? 0})
                  </p>
                  <div className="row d-flex align-items-center mb-2">
                    <p className="col-md-3 col-xs-12 col-sm-12 star-label">
                      5 Stars
                    </p>
                    <div className="col-md-9 col-sm-8 col-xs-8">
                      <div className="bar-wrapper d-flex align-items-center">
                        <div
                          className="5-start rating-bar"
                          style={{ width: `${fiveStarRatingPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mb-2">
                    <p className="col-md-3 col-xs-12 col-sm-12 star-label">
                      4 Stars
                    </p>
                    <div className="col-md-9 col-sm-8 col-xs-8">
                      <div className="bar-wrapper d-flex align-items-center">
                        <div
                          className="5-start rating-bar"
                          style={{ width: `${fourStarRatingPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mb-2">
                    <p className="col-md-3 col-xs-12 col-sm-12 star-label">
                      3 Stars
                    </p>
                    <div className="col-md-9 col-sm-8 col-xs-8">
                      <div className="bar-wrapper d-flex align-items-center">
                        <div
                          className="5-start rating-bar"
                          style={{ width: `${threeStarRatingPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mb-2">
                    <p className="col-md-3 col-xs-12 col-sm-12 star-label">
                      1 Stars
                    </p>
                    <div className="col-md-9 col-sm-8 col-xs-8">
                      <div className="bar-wrapper d-flex align-items-center">
                        <div
                          className="5-start rating-bar"
                          style={{ width: `${twoStarRatingPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mb-2">
                    <p className="col-md-3 col-xs-12 col-sm-12 star-label">
                      1 Stars
                    </p>
                    <div className="col-md-9 col-sm-8 col-xs-8">
                      <div className="bar-wrapper d-flex align-items-center">
                        <div
                          className="5-start rating-bar"
                          style={{ width: `${oneStarRatingPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center mb-2">
                    <p className="col-md-3 col-xs-12 col-sm-12 star-label">
                      Not Rated
                    </p>
                    <div className="col-md-9 col-sm-8 col-xs-8">
                      <div className="bar-wrapper d-flex align-items-center">
                        <div
                          className="5-start rating-bar"
                          style={{ width: '0%' }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 2 && (
              <div className="container" style={{ width: '100%' }}>
                <div className="my-4 mb-5">
                  <CustomDropdown
                    title={'Show Performance'}
                    setFilterOption={setEarningsFilterOption}
                    filterOption={earningsFilterOption}
                    isYearlyDropdown={true}
                  />
                </div>
                <div className="current-metrics stats">
                  <p className="text-left fs-24 font-weight-bold mb-1">
                    Current Metrics
                  </p>
                  <div className="d-flex justify-content-between mb-1">
                    <p>Response Rate</p>
                    <p className="fs-12 color-primary">
                      {monthlyReports?.performance?.response_rate}%
                    </p>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <p>Acceptance</p>
                    <p className="fs-12 color-primary">
                      {monthlyReports?.performance?.acceptance_rate}%
                    </p>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <p>Reliability</p>
                    <p className="fs-12 color-primary"></p>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <p>No Show</p>
                    <p className="fs-12 color-primary">####</p>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <p>Late Cancel</p>
                    <p className="fs-12 color-primary">####</p>
                  </div>
                </div>
                <div className="stats mt-5 text-left">
                  <p className="mb-2">
                    <span></span>
                    <span className="fs-20">
                      ${monthlyReports?.performance?.earnings} Style Earnings
                    </span>
                  </p>
                  <p className="mb-2">
                    <span></span>
                    <span className="fs-20">
                      ${monthlyReports?.performance?.upcoming} Upcoming Earnings
                    </span>
                  </p>
                  <p className="mb-2">
                    <span></span>
                    <span className="fs-20">
                      ${monthlyReports?.performance?.missed} Missed Earnings
                    </span>
                  </p>
                  <p className="mb-2">
                    <span></span>
                    <span className="fs-20">$0 Reimbursements</span>
                  </p>
                </div>
                <div className="text-center mt-5">
                  <h3 className="fs-36 text-black text-capitalize font-weight-bold">
                    Resources
                  </h3>
                  <p className="fs-24 color-primary">
                    View Transaction History
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    // </ThemeProvider>
  )
}

export default MyBusiness
